import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import { store } from '../../store/store';
import { Provider } from 'react-redux';
import { parseBoolean } from '../../Utils/form.util';
import ServiceScheduleCalendar from '../../Modules/Calendar/Components/ServiceScheduleCalendar/ServiceScheduleCalendar';
import { ServiceScheduleType } from '../../graphql/graphql';
import { ServiceScheduleContextProvider } from '../../Modules/WorkplaceMember/Services/ServiceScheduleContext';

loadDOMComponent({
	selector: 'react-workplace-schedule-calendar',
	callback: ({ container, context }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const showNotification = container.getAttribute('showNotification');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<ServiceScheduleContextProvider workplaceId={workplaceId}>
						<ServiceScheduleCalendar
							scheduleTypes={[
								ServiceScheduleType.Shift,
								ServiceScheduleType.ShiftExtra,
							]}
							workplaceId={workplaceId}
							showNotification={parseBoolean(showNotification)}
						/>
					</ServiceScheduleContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
